import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'

import { getAnalytics, logEvent } from "firebase/analytics";
import axios from 'axios';

import BottomMenu from '../components/BottomMenu';
import Loading from '../components/Loading';
import TopBar from '../components/TopBar';

import TrackInfoRow from '../components/TrackInfoRow';
import PreviewInfosVertical from '../components/PreviewInfosVertical';
import { buildMissingRoute } from '../utils/missingRoute';


const EpisodeHighlights = () => {
    const audio = document.getElementById('audio');
    const location = useLocation();
    const navigate = useNavigate();
    let params = useParams();
    const analytics = getAnalytics();
    const missingRoute = buildMissingRoute(location);

    const [trackInfo, setTrackInfo] = useState(null);
    const [trackPreviews, setTrackPreviews] = useState(null);

    useEffect(() => {
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'episode_highlights'
        });
    }, [analytics]);

    useEffect(() => {
        audio.pause();
        if (!!params.trackId) {
            axios
                .get(`/track_info/${params.trackId}`)
                .then((res) => {
                    const data = res.data;
                    setTrackInfo(data);
                })
                .catch((err) => {
                    console.log(err);
                    navigate(missingRoute);
                });

            axios
                .get(`/track_previews/${params.trackId}`)
                .then((res) => {
                    if (res.data && res.data.previews) {
                        setTrackPreviews(res.data.previews);
                    } else {
                        setTrackPreviews([]);
                    }
                });
        }
    }, [missingRoute, params]);

    const playTrack = (trackInfo, startSeconds = 0) => () => {
        navigate(`/track/${encodeURIComponent(trackInfo.id)}?autoplay=true&start=${startSeconds}`);
    };

    return (
        <div className='container hasBottomMenu appScreen'>
            <BottomMenu />
            <div style={{ paddingBottom: '20px' }}>
                <TopBar />
                {trackInfo !== null ?
                    <div style={{ paddingBottom: '20px' }}>
                        <div style={{ margin: '20px 0px 30px' }}>
                            <div style={{ padding: '0px 20px 16px' }}>
                                <span className="heading">Episode</span>
                            </div>
                            <TrackInfoRow
                                trackInfo={trackInfo}
                                playTrack={playTrack}
                            />
                        </div>
                        {trackPreviews === null ?
                            <Loading overrideStyle={{ padding: '30px', textAlign: 'center' }} />
                            :
                            trackPreviews.length === 0 ?
                                <div style={{ padding: '0px 20px', color: 'var(--app-text-muted)' }}>
                                    No highlights available
                                </div>
                                :
                                <div>
                                    <div className='entityInfoSectionTitle'>
                                        Highlights
                                    </div>
                                    <div style={{ marginTop: '16px' }}>
                                        <PreviewInfosVertical previews={trackPreviews} title='Episode Highlights'
                                            playbackOrigin={{ kind: 'episode' }} />
                                    </div>
                                </div>
                        }
                    </div>
                    :
                    <div style={{ padding: '20px 0px' }}>
                        <Loading overrideStyle={{ padding: '30px', textAlign: 'center' }} />
                    </div>
                }
            </div>
        </div>
    );
};

export default EpisodeHighlights;
